import { Form, Input, InputNumber, Select, Switch } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal'
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx'
import fetchApi from '../../../utils/api/fetchApi';
import systematic from '../../../config/systematic';
import getList from '../../universal/getList';

//布局
const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

const PaymentMethodEdit = (props: any) => {
    const [form] = Form.useForm(); //form 
    const { data } = props;
    /** 后端数据defaultService */
    let defaultService: any = systematic.wmService;
    const [paymentTypeData, setPaymentTypeData] = useState<any>([]);
    const [giftCardPlan, setGiftCardPlan] = useState<any>([])
    const ref = useRef<any>(undefined);
    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'paymentMethod',
    };
    useEffect(() => {
        const fetchData = async () => {
            fetchApi.GET(defaultService,
                {
                    apiId: 'generalData',
                    apiVariable: 'paymentType',
                    apiExtend: 'showLists'
                }
            ).then(res => {
                if (res.success) {
                    const { paymentType } = res.data


                    setPaymentTypeData(paymentType);

                }
            })

            fetchApi.GET(defaultService,
                {
                    apiId: 'giftCardPlans',
                    apiExtend: 'showList'
                }
            ).then(res => {
                if (res.success) {

                    console.log("res", res);


                    setGiftCardPlan(res.data);

                }
            })
            // setCaOrderStatusData
        };
        fetchData()
    }, [])
    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '支付方式'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
            >
                <Form
                    {...layout}
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}>

                    <Form.Item
                        label="id"
                        name="id">
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="支付方式"
                        name="paymentMethodName"
                        rules={[{ required: true, message: '请输入支付方式!' }]}>
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="支付类型"
                        name="paymentType"
                        rules={[{ required: true, message: '请输入支付类型!' }]}>
                        <Select
                            showSearch
                            allowClear
                            placeholder="支付类型"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(paymentTypeData, "name")}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="本金"
                        name="principalAmount"
                    >
                        <InputNumber />
                    </Form.Item>
                    <Form.Item
                        label="抵扣金额"
                        name="deductionAmount"

                    >
                        <InputNumber />
                    </Form.Item>

                    <Form.Item
                        label="团购方案"
                        name="giftCardPlanId"
                        >
                        <Select
                            showSearch
                            allowClear
                            placeholder="支付类型"
                            optionFilterProp="children"
                            filterOption={(input, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                            {getList.general(giftCardPlan, "planName")}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="状态"
                        name="isUse"
                        valuePropName="checked"
                        initialValue={true}>
                        < Switch checked={true}
                            checkedChildren="启用"
                            unCheckedChildren="关闭" />
                    </Form.Item>



                </Form>
            </AntDraggableModal>
        </>
    )
}

export default PaymentMethodEdit;